export default "__VITE_ASSET__CRz3fM11__"